import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";
import { soldeStart } from "./SoldeAction";
import { extractUrlParams } from "../../../../common/utils/Utils";

export const shipmentInfoStart = (action) => {
  console.log(action.payload)
  return (dispatch) => {
    dispatch(action);
    let request = `/search?`;
    if (action.payload.port) {
      request += "port=" + (action.payload.port?.code ? action.payload.port?.code : action.payload.port);
    }
    if (action.payload.numConteneur) {
      request += "&numConteneur=" + action.payload.numConteneur;
    }
    if (action.payload.numConnaissement) {
      request += "&numConnaissement=" + action.payload.numConnaissement;
    }
    if (action.payload.numReservation) {
      request += "&numReservation=" + action.payload.numReservation;
    }
    if (action.payload.eta) {
      request += "&eta=" + action.payload.eta;
    }
    if (action.payload.etd) {
      request += "&etd=" + action.payload.etd;
    }

    axios
      .get(request)
      .then((response) => {
        dispatch(shipmentInfoSuccess(response.data));
        dispatch(
          soldeStart({
            type: ActionTypes.ACTION_SOLDE_START,
            payload: extractUrlParams(window.location.href),
          })
        );
      })
      .catch((error) => {
        dispatch(shipmentInfoFailed(error.response?.data));
      });
  };
};

export const shipmentInfoSuccess = (shipmentInfo) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_SUCCESS,
    payload: shipmentInfo,
  };
};

export const shipmentInfoFailed = (error) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_FAILED,
    payload: error,
  };
};

export const shipmentInfoInit = () => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_INIT,
    payload: "",
  };
};
